import videoFilter from '../page/video/filter';
import videoHtml from '../page/video/html';

ZoneObject.create('.section-videos', {
    run: () => {
        items.create({
            name: 'video',
            data: videoFilter.get,
            first_load: true,
            html: videoHtml,
            modal: {
                selector: '[video-open]',
                data: (id, callback) => {
                    callback(JSON.parse($('[video-open="' + id + '"]').attr('data-json')));

                    $('#video-events').hide();

                    $.get('/video/' + id, response => {
                        if (response && response.events && response.events.length) {
                            $('#video-events').show();

                            items.create({
                                name: 'video-events',
                                glueUnions: true,
                                html: (html, data) => {
                                    if (data.type && data.type.color) {
                                        html.find('[html="type.name"]').css('color', data.type.color);
                                    }

                                    return html;
                                },
                                items: {
                                    data: response.events
                                }
                            });
                        }
                    }, 'json');
                }
            },
            scroll_window: location.href.indexOf('/video') > -1
        });
    }
});